//
//
//
//
//
//
//

export default {
  name: "notification_icon",
  data() {
    return {}
  },
  mounted() {
    //SPF-1260 - for dev testing
    // this.$store.commit('setNotifications', [{}, {}, {}])
  },
  computed: {
    notificationsCount: function () {
      return _.get(this.$store.state, 'notifications', []).length
    },
    hasNotifications: function () {
      return this.notificationsCount > 0;
    },
    isVisible: function () {
      return this.user && !this.$store.state.betslip.visible;
    }
  }
}
